export default __webpack_public_path__ + "static/media/AppraisalPP2.18e71449.jpg";